






























































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode } from '@/api'

export interface InputOfReserveContactSituationUserInfoItem {
  userId: string
  name: string
  nameKana: string
  phoneNumber: string
  phoneType: SystemCode
  reserveContactTime: string
  userType: SystemCode
  reserveContactCount: number
}

export const defaultInputOfReserveContactSituationUserInfoItem = (): InputOfReserveContactSituationUserInfoItem => ({
  userId: '',
  name: '',
  nameKana: '',
  phoneNumber: '',
  phoneType: defaultSystemCode(),
  reserveContactTime: '',
  userType: defaultSystemCode(),
  reserveContactCount: 0
})

@Component({
  components: {}
})
export default class InputOfReserveContactSituationUserInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: InputOfReserveContactSituationUserInfoItem

  get iconOfUser(): string {
    return this.isOrganization(this.item.userType.code) ? 'users' : 'male'
  }

  isOrganization(code: string): boolean {
    return code.startsWith('8')
  }
}
